/**
 * @file The realization insight
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LocalisationService } from '../../core/localisation.service';
import { InsightService } from '../insight.service';
import { InsightProvider } from '../insight-provider';
import { InsightTextComponent } from '../insight-text/insight-text.component';
import { durationToText } from '../../core/helpers/durationToText';
import { ComponentRegistry } from '../../core/component-registry';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Displays the number of hours booked during the displayed period.
 * @export
 * @class InsightRealizationComponent
 * @extends {InsightTextComponent}
 * @implements {OnDestroy}
 */
var InsightRealizationComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightRealizationComponent, _super);
    /**
     * Creates an instance of InsightRealizationComponent.
     * @param {configurationsService} configurationsService The configuration service.
     * @param {InsightProvider} provider Provides the data to be displayed.
     * @param {InsightService} insightService The insight service is used to gather data.
     * @param {LocalisationService} localisationService The localisation service.
     * @memberOf InsightRealizationComponent
     */
    function InsightRealizationComponent(translateService, resourceService, provider, insightService, localisationService, router, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.translateService = translateService;
        _this.localisationService = localisationService;
        _this.alertsService = alertsService;
        /**
         * Contains the date of horizon within the view.
         * @private
         */
        _this.horizonDate = moment().startOf('day');
        _this.horizonLevel = 'week';
        _this.horizonOffset = 'week';
        _this.makeHorizonDateListener(_this.subscriptionPool, router, function (date, level) {
            _this.horizonDate = date;
            _this.horizonLevel = level === 'week' ? 'isoWeek' : level;
            _this.horizonOffset = level;
            _this.refresh();
        });
        return _this;
    }
    Object.defineProperty(InsightRealizationComponent.prototype, "start", {
        /**
         * Gets the start of week with respect to startTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var start = this.horizonDate.clone().startOf(this.horizonLevel);
            return start.toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightRealizationComponent.prototype, "finish", {
        /**
         * Gets finish of week with respect to endTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var date = this.horizonDate.clone().startOf(this.horizonLevel);
            date.add(1, this.horizonOffset);
            var finish = date.toDate();
            if (finish > this.publishedTill) {
                finish = this.publishedTill;
            }
            return finish;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register component by the insight provider.
     * @static
     * @memberOf InsightRealizationComponent
     */
    InsightRealizationComponent.register = function () {
        ComponentRegistry.register('insight', 'InsightRealizationComponent', InsightRealizationComponent);
    };
    /**
     * Updates the insight footer.
     * @memberOf InsightRealizationComponent
     */
    InsightRealizationComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var start, finish;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.refresh.call(this)];
                    case 1:
                        _a.sent();
                        start = this.horizonDate.clone().startOf(this.horizonLevel);
                        finish = start.clone();
                        finish.add(1, this.horizonOffset).subtract(1, 'day');
                        this.data['footerKey'] = start.format(this.localisationService.dayMonth.format);
                        if (!start.isSame(finish)) {
                            this.data['footerKey'] += ' - ' + finish.format(this.localisationService.dayMonth.format);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets the number of booked hours.
     * @memberOf InsightRealizationComponent
     */
    InsightRealizationComponent.prototype.afterItemsLoaded = function () {
        if (!this.loadedItems || this.loadedItems[0]['value'] == null) {
            return;
        }
        var text = this.translateService.instant('APP.INSIGHTS.REALIZATION_START')
            + durationToText(moment.duration(this.loadedItems[0]['value']))
            + this.translateService.instant('APP.INSIGHTS.REALIZATION_END');
        this.setData('realization', text);
    };
    return InsightRealizationComponent;
}(InsightTextComponent));
export { InsightRealizationComponent };
